/**
 * The dashed pill that adds to the answer key: a source, a tool call.
 */

import { Plus } from 'lucide-react';
import { PillButton } from '@/modules/simulator/ui/pill-button';

export const AddButton = ({ label, onClick }: { label: string; onClick: () => void }) => (
	<PillButton dashed onClick={onClick}>
		<Plus className='size-3' />
		{label}
	</PillButton>
);
